<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:38px;font-weight:bold;">Windows FAQ</span><br><br><br>
    <span style="font-size:30px;font-weight:bold;">1、Windows端MOA安装包打不开怎么办？</span><br><br>
    <p><strong>解决办法：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;a、先到安装包下载目录刷新一下。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;b、右键安装包-->"属性",查看安装包大小是否正确，如果不正确则重新下载。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;c、将安装包加入杀毒软件信任白名单。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;d、如果还打不开，请联系信息安全部 jijuntao，yuyutang。</p><br>
    <span style="font-size:30px;font-weight:bold;">2、Windows端MOA如何进行手动更新？</span><br><br>
    <p><strong>解决办法：</strong><p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;“以管理员身份运行”运行安装包，直接覆盖安装即可。</p>
    <span style="font-size:30px;font-weight:bold;">3、Windows端MOA安装时被杀毒软件报为病毒</span><br><br>
    <p><strong>解决办法：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;此为杀毒软件误报，将安装包加入信任白名单即可。</p>
    <span style="font-size:30px;font-weight:bold;">4、Windows端MOA安装时提示需要输入管理员用户名和密码</span><br><br>
    <p><img src="../assets/windows_FAQ/windows_FAQ_pic01.png" width=400px height=420px></p>
    <p><strong>解决办法：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;此为当前用户没有管理员权限，输入管理员密码即可。</p>
    <span style="font-size:30px;font-weight:bold;">5、提示“禁止重复运行itsecClient 程序！”</span><br><br>
    <p><img src="../assets/windows_FAQ/windows_FAQ_pic02.jpg" width=330px height=220px></p>
    <p><strong>原因：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;遇到这种情况说明MOA客户端程序已经运行。如果仍然不能看到MOA运行界面，则重新运行MOA客户端程序。</p>
    <p><strong>解决办法：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;a、先杀掉当前的MOA进程，在任务管理器中结束 itsecClient.exe和itsecClientUpdate.exe。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;b、以管理员权限运行itsecClient.exe。</p>
    <span style="font-size:30px;font-weight:bold;">6、提示“duang！程序遇到问题即将要关闭”</span><br><br>
    <p><img src="../assets/windows_FAQ/windows_FAQ_pic03.jpg" width=400px height=200px></p>
    <p><img src="../assets/windows_FAQ/windows_FAQ_pic04.jpg" width=500px height=200px></p>
    <p><strong>解决办法：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;a、尝试重新运行moa客户端程序。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;b、请联系信息安全部 jijuntao，yuyutang。</p>
    <span style="font-size:30px;font-weight:bold;">7、MOA界面上显示“客户端状态 离线”</span><br><br>
    <p><img src="../assets/windows_FAQ/windows_FAQ_pic05.png" width=600px height=400px></p>
    <p><strong>解决办法：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;a、检查网络是否正常，是否能正常访问互联网和公司办公系统。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;b、询问是否被其他同事扫码。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;c、使用新的安装包重新安装。/p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;d、请联系信息安全部 jijuntao，yuyutang。</p>
    <span style="font-size:30px;font-weight:bold;">8、提示“加载资源文件失败”</span><br><br>
    <p><img src="../assets/windows_FAQ/windows_FAQ_pic06.png" width=700px height=450px></p>
    <p><strong>原因：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;组件缺失，卸载时删掉了资源文件，但是进程还在运行。</p>
    <p><strong>解决办法：</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;使用最新的安装包覆盖安装即可。</p>
    <span style="font-size:30px;font-weight:bold;">9、MOA版本查看</span><br><br>
    <p><img src="../assets/windows_FAQ/windows_FAQ_pic07.png" width=900px height=660px></p>

    </div>
  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {

      },
      kmUrl(URL){
        window.open(URL);
      },
      routerUrl(URL){
        this.$router.push(URL)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:'',
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// windows_FAQ.vue?0fe7a62c